<div class="input-group">

    <!-- <input id="{{ 'loc' + fieldKey }}" autocomplete="off" type="text" class="form-control padding-right-30"
            [formControl]="formControl" [formlyAttributes]="field" (input)="onTextInput()" (click)="fnOnInputClick()"
            (keyup)="fnSearchAddress($event.target.value)" (keypress)="fnKeypress($event.target.value)"
             (blur)="fnCloseGoogleDropdown()" (keydown)="fnKeyDown()"
            [ngClass]="{'has-value': formControl.value,'disabled color-light-grey-disabledType': to.disabled }">

        <label [ngClass]="{'disabled color-light-grey-disabledType': to.disabled }" for="ExpenseCategory">
            {{field.templateOptions.label}}{{gm_lable}}<span *ngIf="to.required">*</span>
        </label> -->
    <ds-textbox [formControl]="formControl" [formlyAttributes]="field" [textboxInput]="textboxConfig"
        (onInput)="onTextInput()" (onBlur)="fnCloseGoogleDropdown()" (onClick)="fnOnInputClick()"
        (onKeypress)="fnSearchAddress($event.target.value)"></ds-textbox>

    <!-- <span class="icons" *ngIf="!isToDelIconDisplay" (click)="fnSearchPlacePrediction()">
            <a [ngClass]="{'disabled color-light-grey-disabledType': to.disabled }">
                <i class="fas fa-search" aria-hidden="true"></i>
            </a>
        </span> -->
    <span class="icons" *ngIf="isToDelIconDisplay && !to.disabled" (click)="fnDeleteText()">
        <a>
            <i class="fas fa-times-circle color-light-grey" aria-hidden="true"></i>
        </a>
    </span>

    <div class="dropdown-menu dropdown-menu-list" [ngClass]="{ active: isHomeOfcDropdownVisible 
            || isCurrentLocationVisible }">
        <ul>
            <li *ngIf="model.currentLocation && isCurrentLocationVisible" (click)="fnSetCurrentLocation()"
                style="margin-top: 5px;">
                <p class="fw-700 py-2">
                    <i class="fas fa-location pr-1"></i>
                    {{'current_location' | translate }}
                </p>
            </li>
            <li (click)="fnSetAddressFromTriangulation(model.userHomeAddressInfo)" *ngIf="isHomeOfcDropdownVisible">
                <p>
                    <strong>{{'home' | translate }}</strong>
                </p>
                <p>
                    {{model?.userHomeAddressInfo?.address}}
                </p>
            </li>
            <li (click)="fnSetAddressFromTriangulation(model.userOfficeAddressInfo)" *ngIf="isHomeOfcDropdownVisible">
                <p>
                    <strong>{{'office' | translate }}</strong>
                </p>
                <p>
                    {{model?.userOfficeAddressInfo?.address}}
                </p>
            </li>
            <li *ngIf="model.isOtherOfficeAvailable" (click)="isOfficeAddressPanel = true;" style="margin-top: 5px;">
                <p>
                    <strong>{{'office_address_other' | translate }}</strong>
                </p>
            </li>

        </ul>
    </div>
    <div class="dropdown-menu dropdown-menu-list" [ngClass]="{ active: isGoogleDropdownVisible }">
        <ul *ngFor="let item of googleDynamicAddressList">
            <li (click)="fnSetAddress(item)"> {{item.description}} </li>
        </ul>
    </div>

    <div class="dropdown-menu dropdown-menu-list" [ngClass]="{ active: isGoogleAddressNotFound }">
        <ul>
            <li>{{'no_match_found' | translate }}</li>
        </ul>
    </div>

    <div *ngIf="formControl.errors && formControl.errors.required && isFormSubmitted" class="alert-danger">
        <span *ngIf="!formControl.value || !formControl.value.trim()">
            <b>{{ "label_Required" | translate }}</b>
        </span>
    </div>
    <div class="float-left w-100pc f-15"
        *ngIf="model.googleCallsInfo && model.googleCallsInfo.notesForGoogle && isGoogleNotesDisplay">
        <div class="float-left text-left">
            <small class="color-red">
                {{ model.googleCallsInfo.notesForGoogle }}
            </small>
        </div>
    </div>
</div>
<office-address-panel *ngIf="isOfficeAddressPanel" (closePanelEvent)="closeOfficeAddPanel($event)">
</office-address-panel>